import React from "react";
import { Route } from "react-router-dom";
import { setTitleAndFaviconForAurora } from "helpers";
import { Header } from "../header";

import styles from "./router.module.scss";

export const AnonymousRoute = ({ component: Component, pageName, ...rest }) => {
	return (
		<Route
			{...rest}
			render={props => {
				setTitleAndFaviconForAurora(pageName);
				return (
					<>
						<Header />
						<div className={styles.container}>
							<Component {...props} />
						</div>
					</>
				);
			}}
		/>
	);
};
